
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { useContext } from "react";
import { Box, Text } from "rebass/styled-components";
import useTranslation from "next-translate/useTranslation";
import Layout from "../components/Layout";
import HeroLanding from "../components/landings/HeroLanding";
import TextWithImg from "../components/TextWithImg";
import FeaturedIn from "../components/home/FeaturedIn";
import OptionsGrid, { OptionsTileProps } from "../components/common/OptionsGrid";
import { LocaleContext } from "../components/locale";
import AboutNumbersGrid from "../components/about/AboutNumbersGrid";
import { pushRoute } from "../lib/routing";
import { useIsMobile, withDeviceType } from "../lib/media";
import { UserType } from "../enums";
interface Props {
    deviceType?: string;
}
function About(props: Props) {
    const { deviceType } = props;
    const { t } = useTranslation("about");
    const isMobileViewport = useIsMobile(deviceType);
    const { country: countryCtx } = useContext(LocaleContext) || {};
    // Images
    const imgCover = "/images/about/aboutus_header_desktop.webp";
    const imgWhy = "/images/about/aboutus_why.webp";
    let imgOurBeginning = "/images/about/aboutus_es.webp";
    let imgName = "";
    if (countryCtx) {
        if (["dk", "no", "se"].includes(countryCtx)) {
            imgName = "nord";
        }
        else if (["de", "fr"].includes(countryCtx)) {
            imgName = "fr_de";
        }
        else {
            imgName = countryCtx;
        }
        imgOurBeginning = "/images/about/aboutus_" + imgName + ".webp";
    }
    // Actions
    const findSitter = () => {
        pushRoute({ pathname: "/search" });
    };
    const becomeSitter = () => {
        pushRoute({
            pathname: "/signup",
            search: { type: UserType.CAREGIVER }
        });
    };
    // Options Grid
    const iconsOptions = ["dog-whiskers", "user"];
    const btnActions = [findSitter, becomeSitter];
    const itemsOptions = [...Array(2)].map((_, i) => {
        return {
            icon: iconsOptions[i],
            title: t(`optionsTitle${i + 1}`),
            btnText: i === 1 && isMobileViewport ? t("start") : t(`optionsBtn${i + 1}`),
            btnAction: btnActions[i]
        };
    }) as OptionsTileProps[];
    return (<Layout withTransparentHeader title={t("pageName")} displayFooterAreas withHrefLang>
      <HeroLanding isMobileViewport={isMobileViewport} imgsrc={imgCover} imgAlt={t("pageName")} title={t("title")} button={{ text: t("start"), onSubmit: findSitter }}/>

      {!isMobileViewport && <Box height={32}/>}

      <TextWithImg title={t("ourBeginningTitle")} imgsrc={imgOurBeginning} imgAlt={t("ourBeginningTitle")} imgRight={isMobileViewport} height={["inherit", "inherit", 390]}>
        <Text as="p" variant={"textWithImg.text"}>
          {t("ourBeginningDesc")}
        </Text>
      </TextWithImg>

      <AboutNumbersGrid />

      <TextWithImg title={t("whyTitle")} imgsrc={imgWhy} imgAlt={t("whyTitle")} imgRight>
        <Text as="p" variant={"textWithImg.text"}>
          {t("whyDesc")}
        </Text>
      </TextWithImg>

      <FeaturedIn showTitle={false}/>

      <OptionsGrid title={t("optionsTitle")} items={itemsOptions}/>

      {!isMobileViewport && <Box height={32}/>}
    </Layout>);
}
const getServerSideProps = withDeviceType()();
export default About;

    async function __Next_Translate__getServerSideProps__1987f3f21b8__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/about',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1987f3f21b8__ as getServerSideProps }
  